import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../../context/NavigationContext";
import { CreateChannelContext } from "../../../context/CreateChannelContext";
import { updateChannel } from "../../../api/channels/channelServices";
import { ActionItem, ActionOnItem, ChannelState, ChannelSubstate, getCreatorActionableItems, SKChannel } from "../../../models/SKChannel";
import { getCountryName, getLanguageName } from "../../../utils/stringFunctions";
import { format } from "date-fns";
import HistoryNavigator from "./components/HistoryNavigator";
import { TopicTypeString } from "../../../models/SKArtifact";

export default function ChannelPreview() {
  const { channelData, updateChannelData } = useContext(CreateChannelContext);
  const navigate = useNavigate();
  const { setNavProps } = useNavigationBar();
  const [isLoading, setIsLoading] = useState(false);
  const [actionOnItem, setActionOnItem] = useState<ActionOnItem | null>(null);
  // const location = useLocation();
  // const [channelState, setChannelState] = useState({ key: "", value: "" });

  const getPopItemsForId = (): ActionItem[] => {
    if (channelData) {
      const { status, subStatus } = channelData;
      return getCreatorActionableItems({ state: status, subState: subStatus });
    }
    return [];
  };

  useEffect(() => {
    const updateChannels = async () => {
      setIsLoading(true);
      if ((channelData.status = ChannelState.IN_REVIEW)) {
      }

      await updateChannel(channelData.id as string, {
        status: ChannelState.IN_REVIEW,
        subStatus: ChannelSubstate.NONE,
      });
      setIsLoading(false);
      navigate("../success");
    };

    setNavProps({
      backArrow: false,
      title: "Channel",
      subtitle: "Creator Channel",
      buttonTitle: [ChannelState.IN_REVIEW, ChannelState.ACTIVE].includes(channelData.status)
        ? channelData.status === ChannelState.ACTIVE
          ? "Request Edit"
          : "In Review"
        : "Submit",
      getActionItems: getPopItemsForId,
      enableLink: channelData.status === ChannelState.DRAFT ? true : channelData.status === ChannelState.ACTIVE ? true : false,
      onActionItemSelect: actionItem => {
        setActionOnItem({ itemid: channelData.id!, action: actionItem as ActionItem });
      },
      onNext: () =>
        [ChannelState.IN_REVIEW, ChannelState.ACTIVE].includes(channelData.status)
          ? channelData.status === ChannelState.IN_REVIEW
            ? {}
            : requestEdit()
          : updateChannels(),
    });
  }, [setNavProps, channelData]);

  const requestEdit = async () => {
    navigate("../edit-channel");
  };

  return <ShowChannelDetail channel={channelData} />;
}

interface ChannelDetailProps {
  channel: SKChannel;
}

export const ShowChannelDetail = ({ channel }: ChannelDetailProps) => {
  return (
    //channel-page-context
    <div className="bg-white mt-[15px]">
      <div className="flex flex-col">
        <div className="flex flex-col w-full">
          {channel.id && !(channel.status === ChannelState.DRAFT && channel.subStatus === ChannelSubstate.NONE) ? (
            <HistoryNavigator title="Channel Status" docId={channel.id} />
          ) : (
            ""
          )}

          <div className="mb-[15px] flex flex-col min-w-[290px] min-h-[96px] max-w-[481px] max-h-[150px]">
            {channel.backgroundImageUrl && (
              <img
                className="min-w-[290px] min-h-[96px] max-w-[481px] max-h-[150px] bg-gray-700"
                src={channel.backgroundImageUrl}
                alt=""
                style={{
                  borderColor: "grey",
                  borderWidth: "0.05rem",
                  borderStyle: "solid",
                  margin: "1px",
                }}
              />
            )}
          </div>
          <div className="mb-[10px] flex flex-col items-start min-w-[60px] min-h-[60px] max-w-[75px] max-h-[75px] rounded-full">
            {/* {progress > 0 && <progress value={progress} max="100" />} */}
            {channel.profileImageUrl && (
              <img
                //src="/icons/profileimg.png"
                src={channel.profileImageUrl}
                className="min-w-[60px] min-h-[60px] max-w-[75px] max-h-[75px] rounded-full"
                style={{
                  borderColor: "grey",
                  borderWidth: "0.05rem",
                  borderStyle: "solid",
                  margin: "1px",
                  borderRadius: "6.375rem",
                }}
                alt=""
              />
            )}
          </div>

          <div className="flex flex-col max-w-[480px]">
            <div className="mb-[5px] flex flex-col w-full">
              <label className="channel-preview-title">{channel.name}</label>
            </div>
            <div className="mb-[15px] items-center flex flex-row w-full gap-[5px]">
              <img src="/icons/VerificationBadge.png" alt="Saving" className="w-[22px] h-[22px]" />

              <label className="channel-preview-verification">Verified</label>
            </div>
            <div className="mb-[5px] flex flex-col w-full">
              <label className="capitalize channel-preview-topic-title">{channel.topic ? TopicTypeString[channel.topic] : ""}</label>
            </div>
            <div className="mb-[30px] flex flex-col w-full">
              <label className="channel-preview-topic-descptn">{channel.description}</label>
            </div>
          </div>
          <div className="flex gap-[15px] flex-col w-full">
            {/* <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">State</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">
                  {channel.status === ChannelState.IN_REVIEW
                    ? "Channel under Review..."
                    : "Published"}
                </label>
              </div>
            </div> */}
            <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">Age Rating</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">Age {channel.age}+</label>
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">Language</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">
                  {getLanguageName(channel.language!) + ", " + getLanguageName(channel.secondLanguage!)}
                </label>
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">Country</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">{getCountryName(channel.country!)}</label>
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">Last Published</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">{format(channel.createdDate?.toDate() || new Date(), "MMM, dd yyyy")}</label>
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">Last Modified</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">{format(channel.createdDate?.toDate() || new Date(), "MMM, dd yyyy")}</label>
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div className="mb-[5px] flex flex-col w-full">
                <label className="channel-preview-sub-topic-title">Created</label>
              </div>
              <div className="flex flex-col w-full">
                <label className="channel-preview-sub-topic-value">{format(channel.createdDate?.toDate() || new Date(), "MMM, dd yyyy")}</label>
              </div>
            </div>
          </div>
          {/* {channel.status === ChannelState.IN_REVIEW ? (
            <div className="flex flex-col w-full mb-5">
              <label className="block mb-2 text-sm text-gray-400">State</label>
              <label className="block mb-2 text-sm font-semibold text-gray-900 dark:text-white">
                Channel under Review...
              </label>
            </div>
          ) : (
            ""
          )} */}
        </div>
      </div>
    </div>
  );
};
